import themeColors from 'assets/theme/colors'

const classes = {
  linkBox: {
    cursor: 'pointer',
    paddingTop: '6px'
  },
  upperBox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: '16px',
    marginBottom: '-4px'
  },
  underBox: {
    height: '3px',
    background: themeColors.bg.light,
    opacity: 0.65,
    marginTop: '25px',
    marginLeft: '-20px',
    marginRight: '-20px'
  },
  subMenuBox: {
    position: 'absolute',
    top: '100%',
    left: 0,
    background: 'white',
    boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
    borderRadius: '0px',
    minWidth: '200px',
    width: 'max-content',
    zIndex: 10
  },
  subMenuLinkBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 15px',
    cursor: 'pointer',
    '&:hover': { backgroundColor: '#f5f5f5' }
  },
  // A group entry opens its children to the right of the parent panel.
  nestedSubMenuBox: {
    position: 'absolute',
    top: 0,
    left: '100%',
    background: 'white',
    boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
    minWidth: '200px',
    width: 'max-content',
    zIndex: 11
  },
  typoLink: {
    fontSize: '0.937rem',
    textDecoration: 'none',
    color: themeColors.gray.mid //'#fff'
  },
  // Block, so the anchor stretches across the panel and its row fills it.
  subMenuLink: {
    display: 'block',
    fontSize: '0.937rem',
    textDecoration: 'none',
    color: themeColors.gray.mid
  },
  typoItem: {
    color: themeColors.gray.mid,
    fontSize: '0.937rem',
    fontWeight: 600
  },
  itemHover: {
    transform: 'scale(1.1)',
    transition: 'transform 100ms repeat'
  },
  logo: {
    height: '25px'
  },

  dropdownClass: {
    height: 19
  },
  dropdownToogle: {
    cursor: 'pointer',
    width: '100%'
  },
  dropdownMenu: {
    background: 'rgba(255, 255, 255, 1)',
    marginTop: 25,
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px',
    borderRadius: 3,
    marginLeft: '-30px'
  },
  dropdownItemBox: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    minWidth: 380,
    cursor: 'pointer'
  },
  typoToogle: {
    color: '#fff',
    fontFamily: 'inherit',
    fontSize: '0.937rem',
    '&:hover': {
      opacity: 0.9
    },
    '&:active': {
      opacity: 0.85
    }
  },
  imageBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '1.125rem',
    height: 130
  },
  typoBox: {
    paddingLeft: '25px'
  }
}

export default classes
